import React, { useEffect, useState } from 'react';
import ModalComponent from '../../components/ModalComponent';
import '../../assets/style/Modal.css';
import {
  CLICK_ACTIONS,
  DATE_FORMAT,
  REIMBURSEMENT_STATUS_TYPES,
} from '../../utils/Constant';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Badge,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import ModalHeader from '../../components/ModalHeader';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { Button, Input, Label } from 'reactstrap';
import { SelectOptionType } from '../../utils/Types';
import {
  addFourDigitsToTheId,
  checkNullValue,
  formatNumberWithComma,
  formattedDateWithFormat,
  getNoteDate,
  isAPIFailed,
  isAPISuccess,
} from '../../utils/Util';
import PreviewAttachmentModal from './PreviewAttachmentModal';
import {
  approveOrRejectReimbursement,
  fetchReimbursementDetails,
  fetchReimbursementTypes,
  reimbursementSelector,
} from '../../features/reimbursementSlice';
import { toast } from 'react-toastify';
import BasicDetails from '../../components/BasicDetails';
import CenterSpinner from '../../components/CenterSpinner';

export const MODAL_TYPE = {
  apply: 1,
  approve: 2,
};
interface IApplyReimbursementModalProps {
  isOpen: boolean;
  toggleModal: (action?: string) => void;
  modalType: number;
  selectedTask: any;
}

const ApproveReimbursementModal: React.FunctionComponent<
  IApplyReimbursementModalProps
> = ({
  isOpen,
  toggleModal,
  modalType,
  selectedTask,
}: IApplyReimbursementModalProps) => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [comment, setComment] = useState<string>('');
  const [documents, setDocuments] = useState<any[]>([]);
  console.log('shoe->', showLoader);
  const [isAttachmentModelOpen, setIsAttachmentModelOpen] =
    useState<boolean>(false);

  const TYPE_OF_CLAIM: SelectOptionType[] = useAppSelector(
    reimbursementSelector
  )?.reimbursementTypes;
  const reimbursementDetails: any = useAppSelector(
    reimbursementSelector
  )?.approveReimbursementDetails;

  const handleAccordionChange = (index: number | null) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  const dispatch = useAppDispatch();

  const approveReimbursement = (status: number) => {
    const data: any = {
      claimId: Number(reimbursementDetails?.claimId),
      status: status,
    };
    if (status === 1 && !comment.trim()) {
      toast.error('Comment is required');
      return;
    }
    // Add validation for comment length
    if (comment.length > 250) {
      toast.error('Comment cannot exceed 250 characters.');
      return;
    }

    if (comment) {
      data.comment = comment;
    }
    setShowLoader(true);
    dispatch(approveOrRejectReimbursement(data))
      ?.then((fulfilled: any) => {
        setShowLoader(false);
        if (isAPIFailed(fulfilled.payload)) {
          toast.error(fulfilled.payload.responseInformation.responseMessage);
        } else if (isAPISuccess(fulfilled.payload)) {
          if (status == 0) {
            toggleModal(CLICK_ACTIONS?.REIMBURSEMENT_SUCCESS_MODAL);
          } else {
            toast.success(
              fulfilled.payload.responseInformation.responseMessage
            );
            toggleModal();
          }
        }
      })
      .catch(() => {
        setShowLoader(false);
      });
  };

  useEffect(() => {
    dispatch(fetchReimbursementTypes({ module: 7 }));
    dispatch(fetchReimbursementDetails({ claimId: selectedTask?.claimId }));
  }, []);

  const getTravelComponent = (item: any) => {
    return (
      <>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Claim ID</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {addFourDigitsToTheId(reimbursementDetails?.claimId)}
            </Label>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Claim Date and Time</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {item?.claimFromDate
                ? formattedDateWithFormat(
                    item?.claimFromDate,
                    DATE_FORMAT.DD_MM_YYYY_hh_mm_A
                  )
                : '-'}
            </Label>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Starting Point</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(item?.locationA)}
            </Label>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Ending Point</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(item?.locationB)}
            </Label>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">
              Total Distance Travelled (Kms)
            </Label>
            <br />
            <Label className="mb-0 model-label-value">
              {formatNumberWithComma(item?.totalDistance)}
            </Label>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">
              Total Expense Incurred (INR)
            </Label>
            <br />
            <Label className="mb-0 model-label-value">
              {formatNumberWithComma(item?.totalExpenses)}
            </Label>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12}>
            <Label className="mb-0 model-label-name">Reason</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(item?.reason)}
            </Label>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Any Documents</Label>
            <br />
            <Badge badgeContent={item?.images?.length || '0'} color="error">
              <Button
                disabled={!item?.images?.length}
                style={{
                  backgroundColor: '#829ED1',
                  border: 'none',
                  borderRadius: '0px',
                }}
                onClick={() => {
                  setIsAttachmentModelOpen(true);
                  setDocuments(item?.images);
                }}
              >
                View Attachments
              </Button>
            </Badge>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Comments</Label>
            <br />
            <Label className="mb-0 model-label-value comments-wrapper">
              {checkNullValue(item?.comments)}
            </Label>
          </Col>
        </Row>
      </>
    );
  };
  const getFoodComponent = (item: any) => {
    return (
      <>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Claim ID</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {addFourDigitsToTheId(reimbursementDetails?.claimId)}
            </Label>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Claim Date and Time</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {item?.claimFromDate
                ? formattedDateWithFormat(
                    item?.claimFromDate,
                    DATE_FORMAT.DD_MM_YYYY_hh_mm_A
                  )
                : '-'}
            </Label>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Location</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(item?.locationA)}
            </Label>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">
              Total Expense Incurred (INR)
            </Label>
            <br />
            <Label className="mb-0 model-label-value">
              {formatNumberWithComma(item?.totalExpenses)}
            </Label>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Any Documents</Label>
            <br />
            <Badge badgeContent={item?.images?.length || '0'} color="error">
              <Button
                disabled={!item?.images?.length}
                style={{
                  backgroundColor: '#829ED1',
                  border: 'none',
                  borderRadius: '0px',
                }}
                onClick={() => {
                  setIsAttachmentModelOpen(true);
                  setDocuments(item?.images);
                }}
              >
                View Attachments
              </Button>
            </Badge>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Comments</Label>
            <br />
            <Label className="mb-0 model-label-value comments-wrapper">
              {checkNullValue(item?.comments)}
            </Label>
          </Col>
        </Row>
      </>
    );
  };
  const getAccommodationComponent = (item: any) => {
    return (
      <>
        <Row className="mt-4">
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">Claim ID</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {addFourDigitsToTheId(reimbursementDetails?.claimId)}
            </Label>
          </Col>
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">
              Claim From Date and Time
            </Label>
            <br />
            <Label className="mb-0 model-label-value">
              {item?.claimFromDate
                ? formattedDateWithFormat(
                    item?.claimFromDate,
                    DATE_FORMAT.DD_MM_YYYY_hh_mm_A
                  )
                : '-'}
            </Label>
          </Col>
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">
              Claim To Date and Time
            </Label>
            <br />
            <Label className="mb-0 model-label-value">
              {item?.claimToDate
                ? formattedDateWithFormat(
                    item?.claimToDate,
                    DATE_FORMAT.DD_MM_YYYY_hh_mm_A
                  )
                : '-'}
            </Label>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Location</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(item?.locationA)}
            </Label>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Hotel Name</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(item?.hotelName)}
            </Label>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Zone</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(item?.zoneName)}
            </Label>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">State</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(item?.stateName)}
            </Label>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">District</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(item?.districtName)}
            </Label>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">City/Village</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(item?.cityName)}
            </Label>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">
              Total Expense Incurred (INR)
            </Label>
            <br />
            <Label className="mb-0 model-label-value">
              {formatNumberWithComma(item?.totalExpenses)}
            </Label>
          </Col>
          <Col xs={6}>
            <Label className="mb-0 model-label-name">Reason</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(item?.reason)}
            </Label>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Any Documents</Label>
            <br />
            <Badge badgeContent={item?.images?.length || '0'} color="error">
              <Button
                disabled={!item?.images?.length}
                style={{
                  backgroundColor: '#829ED1',
                  border: 'none',
                  borderRadius: '0px',
                }}
                onClick={() => {
                  setIsAttachmentModelOpen(true);
                  setDocuments(item?.images);
                }}
              >
                View Attachments
              </Button>
            </Badge>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Comments</Label>
            <br />
            <Label className="mb-0 model-label-value comments-wrapper">
              {checkNullValue(item?.comments)}
            </Label>
          </Col>
        </Row>
      </>
    );
  };
  const getMiscellaneousComponent = (item: any) => {
    return (
      <>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Claim ID</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {addFourDigitsToTheId(reimbursementDetails?.claimId)}
            </Label>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Claim Date and Time</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {item?.claimFromDate
                ? formattedDateWithFormat(
                    item?.claimFromDate,
                    DATE_FORMAT.DD_MM_YYYY_hh_mm_A
                  )
                : '-'}
            </Label>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Miscelleanous</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(item?.locationA)}
            </Label>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">
              Total Expense Incurred (INR)
            </Label>
            <br />
            <Label className="mb-0 model-label-value">
              {formatNumberWithComma(item?.totalExpenses)}
            </Label>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Any Documents</Label>
            <br />
            <Badge badgeContent={item?.images?.length || '0'} color="error">
              <Button
                disabled={!item?.images?.length}
                style={{
                  backgroundColor: '#829ED1',
                  border: 'none',
                  borderRadius: '0px',
                }}
                onClick={() => {
                  setIsAttachmentModelOpen(true);
                  setDocuments(item?.images);
                }}
              >
                View Attachments
              </Button>
            </Badge>
          </Col>
          <Col xs={6} md={6}>
            <Label className="mb-0 model-label-name">Comments</Label>
            <br />
            <Label className="mb-0 model-label-value comments-wrapper">
              {checkNullValue(item?.comments)}
            </Label>
          </Col>
        </Row>
      </>
    );
  };
  const getMainComponent = (claim: any, item: any) => {
    switch (claim) {
      case TYPE_OF_CLAIM[0]?.value:
        return getTravelComponent(item);
      case TYPE_OF_CLAIM[1]?.value:
        return getFoodComponent(item);
      case TYPE_OF_CLAIM[2]?.value:
        return getAccommodationComponent(item);
      case TYPE_OF_CLAIM[3]?.value:
        return getMiscellaneousComponent(item);
    }
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={() => {
        toggleModal(CLICK_ACTIONS.NO_ACTION);
      }}
      className="modalWrapper"
      backdrop="static"
    >
      <div className="d-flex justify-content-center">
        <div className="bg-white rounded border re-modal-width">
          <div className="m-2">
            <ModalHeader
              photoUrl={reimbursementDetails?.photo}
              toggle={toggleModal}
            />
          </div>

          <div className="re-parent">
            <BasicDetails employeeKeyShow={true} user={reimbursementDetails} />
            <Label className="re-claim-detail">Claim Details</Label>

            {reimbursementDetails?.claimDetails?.length ? (
              reimbursementDetails?.claimDetails?.map(
                (item: any, index: number) => (
                  <Accordion
                    key={item?.reimbursementTypeId}
                    expanded={index === expandedIndex}
                    onChange={() => handleAccordionChange(index)}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '14px',
                        }}
                      >
                        {item?.reimbursementTypeName}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        {getMainComponent(
                          Number(item?.reimbursementTypeId),
                          item
                        )}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                )
              )
            ) : (
              <></>
            )}
          </div>
          <div className="bg-comment p-4 my-2 mx-4 rounded">
            {reimbursementDetails?.statusId ==
              REIMBURSEMENT_STATUS_TYPES?.APPROVAL_PENDING && (
              <div className="mb-3">
                <FormGroup>
                  <Label for="comment" className="model-comment-title">
                    Comments &#40;<span className="text-danger ">* </span>{' '}
                    Mandatory for Rejection&#41;
                  </Label>
                  <Input
                    id="comment"
                    name="comment"
                    type="textarea"
                    value={comment}
                    placeholder="Please Comment"
                    className="rounded border model-comment-area"
                    onChange={(event) => {
                      if (event.target.value.length <= 250) {
                        setComment(event.target.value);
                      }
                    }}
                    maxLength={250} // Add maxLength attribute here
                  />
                  {comment.length > 250 && (
                    <span className="text-danger">
                      Comment cannot exceed 250 characters.
                    </span>
                  )}
                </FormGroup>
              </div>
            )}

            <div className="bg-white rounded border px-4 pt-3 pb-3">
              <Label for="comment" className="model-comment-title">
                Log Details
              </Label>
              <div className="modal-log-div">
                <ul className="li-item model-log-value">
                  {reimbursementDetails?.notes?.length ? (
                    reimbursementDetails?.notes?.map(
                      (noteItem: any, index: number) => (
                        <li
                          className="mt-1"
                          key={`noteItem-li-${noteItem?.notesid ?? noteItem?.notesId}`}
                        >
                          {getNoteDate(noteItem)}
                          {noteItem.notesDescription}
                        </li>
                      )
                    )
                  ) : (
                    <>-</>
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center re-button-parent">
            {reimbursementDetails?.statusId ==
            REIMBURSEMENT_STATUS_TYPES?.APPROVAL_PENDING ? (
              <>
                <Button
                  variant="primary"
                  className="me-2 cl-btn-primary"
                  onClick={() => {
                    approveReimbursement(0);
                  }}
                >
                  Approve
                </Button>
                <Button
                  variant="outline-primary"
                  className="ms-3 cl-btn-outline-primary"
                  onClick={() => {
                    approveReimbursement(1);
                  }}
                >
                  Reject
                </Button>
              </>
            ) : (
              <>
                {' '}
                <Button
                  variant="outline-primary"
                  className="ms-3 cl-btn-outline-primary"
                  onClick={() => {
                    toggleModal();
                  }}
                >
                  Close
                </Button>
              </>
            )}
          </div>
        </div>
        <PreviewAttachmentModal
          isOpen={isAttachmentModelOpen}
          toggleModal={() => {
            setDocuments([]);
            setIsAttachmentModelOpen(!isAttachmentModelOpen);
          }}
          documents={documents}
        />
        <CenterSpinner showLoader={showLoader} className="spinner-60" />
      </div>
    </ModalComponent>
  );
};

export default ApproveReimbursementModal;
